import { AudioManager } from "../AudioManager";
import { GameVars } from "../GameVars";
import { Button } from "../utils/Button";

export class AudioButtonContainer extends Phaser.GameObjects.Container {

    private audioOnButton: Button;
    private audioOffButton: Button;
    private callBack: Function;
    private context: any;

    constructor(scene: Phaser.Scene, callBack?: Function, context?: any) {
        
        super(scene);

        this.callBack = callBack;
        this.context = context;

        this.audioOnButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_sound_on", "btn_sound_on");
        this.audioOnButton.onDown(this.onClickAudioButton, this);
        this.audioOnButton.setInflationTween(1.1);
        this.add(this.audioOnButton);

        this.audioOffButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_sound_off", "btn_sound_off");
        this.audioOffButton.onDown(this.onClickAudioButton, this);
        this.audioOffButton.setInflationTween(1.1);
        this.add(this.audioOffButton);

        this.audioOnButton.visible = GameVars.gameData.muted;
        this.audioOffButton.visible = !GameVars.gameData.muted;
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();

        this.audioOnButton.visible = GameVars.gameData.muted;
        this.audioOffButton.visible = !GameVars.gameData.muted;

        if (this.callBack) {
            this.callBack.call(this.context);
        }

        AudioManager.playSound("btn_click");
    }
}
